export default __webpack_public_path__ + "static/media/forum-disukusi-asset.f37c7cb7.jpeg";